import React from "react";
import "./Discography.css";
import CMS from "../cms.json";

const artistLinks = CMS.discography.artistLinks || {};
const SPOTIFY_ARTIST_URL = artistLinks.spotify || CMS.socials?.spotify || "";
const APPLE_MUSIC_ARTIST_URL = artistLinks.appleMusic || CMS.socials?.appleMusic || "";
const socialIcons = CMS.socials?.icons || {};

const DiscographySection = () => {
  const { released } = CMS.discography;
  const looped = [...released, ...released, ...released, ...released];

  return (
    <section id="discography" className="discography-section">
      <div className="discography-container">
        <div className="section-header">
          <h2 className="section-title">Releases</h2>
          <div className="section-line"></div>
        </div>

        <div className="disco-strip-wrapper">
          <div className="disco-strip-track">
            {looped.map((release, i) => (
              <div key={i} className="disco-cover-card">
                <div className="disco-cover-inner">
                  <img
                    src={release.artwork}
                    alt={release.title}
                    className="disco-cover-img"
                  />
                  <div className="disco-cover-overlay">
                    <p className="disco-overlay-title">{release.title}</p>
                    <p className="disco-overlay-desc">{release.description}</p>
                  </div>
                </div>
                <p className="disco-cover-title">{release.title}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="disco-stream-actions">
          <a
            href={SPOTIFY_ARTIST_URL}
            className="disco-stream-btn spotify"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={socialIcons.spotify}
              alt=""
              aria-hidden="true"
            />
            Stream on Spotify
          </a>
          <a
            href={APPLE_MUSIC_ARTIST_URL}
            className="disco-stream-btn apple"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={socialIcons.appleMusic}
              alt=""
              aria-hidden="true"
            />
            Stream on Apple Music
          </a>
        </div>
      </div>
    </section>
  );
};

export default DiscographySection;
